import { Input } from "@/core/components/ui/input";
import { Stack } from "@/core/components/ui/stack";
import { Textarea } from "@/core/components/ui/textarea";
import { Typography } from "@/core/components/ui/typography";

const BusinessInfoPair = ({
  isEditMode,
  isTextArea,
  label,
  onChange,
  placeholder,
  value,
  className,
  name,
}: {
  isEditMode?: boolean;
  isTextArea?: boolean;
  label: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  placeholder?: string;
  value?: string | null;
  className?: string;
  name?: string;
}) => (
  <Stack className={className || "size-1/4"}>
    {!isEditMode ? (
      <Stack gap="sm" fullWidth>
        <Typography variant="subtitleW3" textColor="tertiary">
          {label}
        </Typography>
        <Typography variant="bodyW1">{value}</Typography>
      </Stack>
    ) : isTextArea ? (
      <Stack gap="sm" fullWidth>
        <Typography variant="captionW1SemiBold" textColor="tertiary">
          {label}
        </Typography>
        <Textarea
          value={value || ""}
          label=""
          onChange={onChange}
          placeholder={placeholder}
        />
      </Stack>
    ) : (
      <Input
        value={value || ""}
        label={label}
        fullWidth
        onChange={onChange}
        placeholder={placeholder}
        name={name}
      />
    )}
  </Stack>
);

export default BusinessInfoPair;
